import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  CampaignNodeSchema,
  ChannelNodeSchema,
  MediaMappingMediaplansSchema,
  MediaplanNodeSchema,
  MediaRowNodeSchema,
  PlatformCampaignNodeSchema,
  PlanMappingRowSchema,
  PlatformNodeSchema,
} from './schemas.js';

export type CampaignNodeType = z.infer<typeof CampaignNodeSchema>;
export type MediaplanNodeType = z.infer<typeof MediaplanNodeSchema>;
export type ChannelNodeType = z.infer<typeof ChannelNodeSchema>;
export type PlatformNodeType = z.infer<typeof PlatformNodeSchema>;
export type MediaRowNodeType = z.infer<typeof MediaRowNodeSchema>;
export type PlatformCampaignNodeType = z.infer<
  typeof PlatformCampaignNodeSchema
>;
export type PlanMappingRowType = z.infer<typeof PlanMappingRowSchema>;
export type MediaMappingMediaplansType = z.infer<
  typeof MediaMappingMediaplansSchema
>;

export const getMediaMappingMediaplans = defaultClient.query({
  url: 'ai-assistant/media_mapping/media_mapping_mediaplans' as const,
  method: 'GET',
  responseSchema: MediaMappingMediaplansSchema,
});
